import {AbsctractValidator} from "./AbstractValidator";

export class DateValidator extends AbsctractValidator {
    constructor(input) {
        super(input);
        this.input = input;
    }
    isValid() {
        let day = this.input.slice(0, 2);
        let month = this.input.slice(2, 4);
        if((day > "31" || day < "01") || month === "02" && day > "29") {
            return false;
        }
        if ((month === "04" || month === "06" || month === "09" || month === "11") && day > "30") {
            return false;
        }
        return true;
    }
    message() {
        return !this.isValid() ? "Data inválida" : "OK";
    }
}





// WEBPACK FOOTER //
// ./src/validator/DateValidator.js